"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSToggleButton = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var BDSToggleButton_style_1 = require("./BDSToggleButton.style");
var BDSToggleButton = function (props) {
    var propsObj = props;
    var handleClickToggle = function () {
        if (!props.disabled) {
            if (propsObj.onChangeToggle) {
                propsObj.onChangeToggle(!props.active);
            }
        }
    };
    return (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "toggle-panel " + (props.active ? "active" : '') + " " + (props.disabled ? 'disabled' : '') + " " + props.appearance, css: [BDSToggleButton_style_1.baseCss], onClick: function (event) {
            event.stopPropagation();
            handleClickToggle();
        }, style: { fontSize: propsObj.size, color: propsObj.color } }, { children: jsx_runtime_1.jsx("div", { className: "circle" }, void 0) }), void 0));
};
exports.BDSToggleButton = BDSToggleButton;
